<script setup lang="ts">
import type { NuxtError } from '#app'
import AppErrorShell from '~/components/layout/AppErrorShell.vue'

const props = defineProps<{
    error: NuxtError
}>()

const { t } = useI18n()

const status = computed(() => props.error.status ?? props.error.statusCode ?? 500)

const pageTitle = computed(() => {
    switch (status.value) {
        case 404:
            return t('Page not found')
        case 403:
            return t('Access denied')
        case 401:
            return t('Session expired')
        default:
            return t('Something went wrong')
    }
})

useHead({
    title: () => `${status.value} · ${pageTitle.value}`,
})
</script>

<template>
    <AppErrorShell :error="error" />
</template>
